"use strict";

var _locales = require("libs/utils/locales");
var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('src/fp-i18n-utils'),
  getAllI18nKeys = _require.getAllI18nKeys;
var minimatch = require('minimatch');
var _require2 = require('src/slugify-utils'),
  reduceAccentsAndSpecialChars = _require2.reduceAccentsAndSpecialChars;
module.exports = /* @ngInject */["$window", "$log", "$route", "$routeParams", "$rootScope", "$scope", "$q", "eventService", "metadataService", "settingsService", "i18nService", "timeService", "bulkUpdateService", "registry", "settings", "i18n", "vueI18n", "modalService", function ($window, $log, $route, $routeParams, $rootScope, $scope, $q, eventService, metadataService, settingsService, i18nService, timeService, bulkUpdateService, registry, settings, i18n, vueI18n, modalService) {
  var _currentRouteDescript;
  var eventId = $routeParams.eventId;
  var event = $rootScope.event;
  $scope.eventId = eventId;
  var currentRouteDescriptor = ($route.current || {}).$$route;
  i18n = $scope.i18n = i18n.data;
  settings = $scope.settings = settings.data;
  $scope.vueI18n = vueI18n;

  // ⚑ TODO: fix name mess
  var registryNavEditors = (registry.data || {}).navs || {};
  registry = (registry.data || {}).settings || {};
  var metadata = metadataService.getCachedMetadata(eventId);

  // settings pane content init begins here

  // helper fn: entries may be arrays or objects in the blueprint. let's handle these two possible inputs
  var pluckSettingsKeyEntriesFn = settingsService.pluckSettingsKeyEntriesFromHashOrList;

  // .. settings & navs

  var settingsKeys = pluckSettingsKeyEntriesFn((currentRouteDescriptor.settings || {}).entries);
  $scope.settingsKeys = settingsKeys;
  $scope.navsKeys = pluckSettingsKeyEntriesFn((currentRouteDescriptor.nav || {}).entries);
  $scope.componentEntries = (_currentRouteDescript = currentRouteDescriptor.components) === null || _currentRouteDescript === void 0 ? void 0 : _currentRouteDescript.entries.map(function (entry) {
    return _objectSpread(_objectSpread({}, entry), {}, {
      i18nKey: "".concat(entry.label)
    });
  });

  // .. i18n

  var i18nMatchers = pluckSettingsKeyEntriesFn((currentRouteDescriptor.i18n || {}).entries || []);

  // process keys. reduce wildcards to sets of actual matched keys
  var i18nKeys = $scope.i18nKeys = [];
  i18nMatchers.forEach(function (matcher) {
    return i18nKeys.push.apply(i18nKeys, getAllI18nKeys(i18n).filter(minimatch.filter(matcher, {
      nocase: true
    })));
  });
  angular.copy(_.uniq(i18nKeys), i18nKeys);
  $scope.topLevelI18nKeys = _.uniq(i18nKeys.map(function (key) {
    var dotIdx;
    if ((dotIdx = key.indexOf('.')) === -1) {
      return key;
    }
    return key.substring(0, dotIdx);
  })).sort();

  // .. nav editors
  var navEditors = currentRouteDescriptor.navEditors;
  if (navEditors) {
    $scope.navEditors = _.chain(navEditors).map(function (descriptor, key) {
      if (!_.isObject(descriptor)) {
        return;
      }
      descriptor.key = key;
      return descriptor;
    }).compact().value();
  }

  // .. all prefs pane items (used to render prefs nav)

  var preferencesPaneItemsObj = {};
  if ((i18nKeys || {}).length) {
    preferencesPaneItemsObj.i18n = currentRouteDescriptor.i18n;
  }
  if (navEditors) {
    preferencesPaneItemsObj.navs = currentRouteDescriptor.navEditors;
  }
  if ((settingsKeys || {}).length) {
    preferencesPaneItemsObj.settings = currentRouteDescriptor.settings;
  }
  _.extend(preferencesPaneItemsObj, currentRouteDescriptor.customItems || {});
  $scope.preferencesPaneItems = _.map(preferencesPaneItemsObj, function (descriptor, key) {
    return _.extend(descriptor, {
      key: key
    });
  });

  // .. custom item docs

  var customPreferencesPaneDocs = $scope.customPreferencesPaneDocs = {};
  $scope.customItemsDescriptors = currentRouteDescriptor.customItems;
  if ($scope.customItemsDescriptors) {
    _.forEach(currentRouteDescriptor.customItems, function (descriptor, key) {
      var promises = descriptor.types.map(function (type) {
        return eventService.getEventDocsByType(event, type);
      });
      return $q.all(promises).then(function (results) {
        customPreferencesPaneDocs[key] = results.reduce(function (arr, results) {
          return arr.concat(results.data);
        }, []);
        // if nothing is selected preselect the first doc in the list we just retrieved
        if (($scope.selectedKey || {}).length || !customPreferencesPaneDocs[key].length) {
          return;
        }
        var docToSelect = _.first(customPreferencesPaneDocs[key]);
        return $scope.selectItem(docToSelect._id, 'item', docToSelect);
      });
    });
  }

  // the remaining init stuff follows

  var isUserEditingUnsavedDoc = false;

  // SEARCH

  var contains = function contains() {
    var big = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var sub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return reduceAccentsAndSpecialChars(big).toLowerCase().indexOf(sub.toLowerCase()) > -1;
  };
  $scope.selectComponentEntry = function (componentEntry) {
    $scope.selectedComponentEntry = componentEntry;
    $scope.selectedKey = null;
  };
  $scope.isComponentEntrySelected = function (componentEntry) {
    return $scope.selectedComponentEntry === componentEntry;
  };
  $scope.filterSettingsKeys = function (itemKey) {
    var filterQueryText = $scope.filterQueryText;
    if (!(filterQueryText || {}).length) {
      return true;
    }
    if (contains(itemKey, filterQueryText)) {
      return true;
    }
    if (_.values(settings[itemKey]).some(function (val) {
      return contains(JSON.stringify(val), filterQueryText);
    })) {
      return true;
    }
    var mdFields = metadataService.convertMetadataHashToOrderedList(registry[itemKey]);
    if (_.values(mdFields).some(function (fieldDescriptor) {
      return contains(fieldDescriptor.field, filterQueryText) || contains(fieldDescriptor.label, filterQueryText);
    })) {
      return true;
    }
  };
  $scope.filterI18nKeys = function (itemKey) {
    var filterQueryText = $scope.filterQueryText;
    if (!filterQueryText) {
      return true;
    }
    // i18n keys themselves don't contain spaces (optimisation)
    if (filterQueryText.indexOf(' ') === -1) {
      if (contains(itemKey, filterQueryText)) {
        return true;
      }
    }
    // but i18n translations CAN contain spaces (so continue the search)
    var translation = (0, _lodash.get)(i18n, "".concat(itemKey, ".en"));
    return contains(translation, filterQueryText);
  };
  $scope.cachedActiveI18nToplevelKeys = {};
  $scope.filterI18nToplevelKeys = function (itemKey) {
    var filterQueryText = $scope.filterQueryText;
    if (!filterQueryText) {
      return true;
    }
    if (!$scope.cachedActiveI18nToplevelKeys[filterQueryText]) {
      $scope.cachedActiveI18nToplevelKeys = {};
      $scope.cachedActiveI18nToplevelKeys[filterQueryText] = _.uniq(i18nKeys.filter($scope.filterI18nKeys).map(function (key) {
        var dotIdx;
        if ((dotIdx = key.indexOf('.')) === -1) {
          return key;
        }
        return key.substring(0, dotIdx);
      }));
    }
    return $scope.cachedActiveI18nToplevelKeys[filterQueryText].includes(itemKey);
  };
  $scope.filterCustomDocs = function (itemDocument) {
    var filterQueryText = $scope.filterQueryText;
    if (!(filterQueryText || {}).length) {
      return true;
    }
    if (_.values(itemDocument).some(function (val) {
      return contains(JSON.stringify(val), filterQueryText);
    })) {
      return true;
    }
    var itemLabel = metadataService.getReprLabelForItem(eventId, itemDocument);
    if (contains(itemLabel, filterQueryText)) {
      return true;
    }
    var mdFields = metadataService.convertMetadataHashToOrderedList(metadata[itemDocument.fp_type]);
    if (_.values(mdFields).some(function (fieldDescriptor) {
      return contains(fieldDescriptor.field, filterQueryText) || contains(fieldDescriptor.label, filterQueryText);
    })) {
      return true;
    }
  };
  $scope.addNewDocumentOfType = function (type, itemKey) {
    var _id;
    if (!_.isArray(customPreferencesPaneDocs[itemKey])) {
      return;
    }
    var metadataForType = metadata[type];
    var defaults = metadataService.extractDefaults(metadataForType);
    var doc = _.extend({}, defaults, {
      fp_type: type,
      fp_ext_id: _id = bulkUpdateService.generateAutoGeneratedValueString(),
      _id: _id
    });
    customPreferencesPaneDocs[itemKey].unshift(doc);
    $scope.selectItem(_id, 'item', doc);
    doc._is_unsaved_prefs_item_doc = true; // flag removed on save
    return isUserEditingUnsavedDoc = true;
  };
  $scope.addTranslationKey = function () {
    modalService.openModalWithForm({
      title: 'Add a new translation key',
      fields: {
        key: {
          order: 1,
          validations: {
            custom: {
              errorMessage: 'Chosen key is either invalid, reserved, or already used.'
            }
          }
        }
      },
      formCanBeSaved: function formCanBeSaved(model, form) {
        var valid = (0, _locales.validateNewI18nKey)(model.key, i18n);
        var field = (0, _lodash.get)(form, 'genericFieldForm.key');
        if (field) {
          field.$setValidity('customValidator', valid);
        }
        return valid;
      }
    }).then(function (model) {
      (0, _lodash.set)(i18nKeys, model.key, {
        en: ''
      });
      $scope.selectItem(model.key, 'i18n');
    });
  };
  $scope.deleteDocument = function (type, doc, itemKey) {
    var event = eventService.decorateScope(eventId);
    modalService.openAlert({
      title: 'Delete template',
      message: 'Are you sure you wish to delete this template?',
      okLabel: 'Yes',
      cancelLabel: 'No'
    }).then(function () {
      bulkUpdateService.deleteDocs(eventId, event.node, type, doc.fp_ext_id);
      var list = $scope.customPreferencesPaneDocs[itemKey];
      var deleteIndex = list.map(function (template) {
        return template._id;
      }).indexOf(doc._id);
      var selectedIndex = list.map(function (template) {
        return template._id;
      }).indexOf($scope.selectedKey);
      delete list[deleteIndex];
      if (deleteIndex === selectedIndex) {
        var newIndex = selectedIndex ? selectedIndex - 1 : selectedIndex + 1;
        $scope.selectItem(list[newIndex]._id, 'item', list[newIndex]);
      }
    });
  };

  // / SEARCH

  var originalSettingsForKey = null;
  $scope.selectItem = function (itemKey) {
    var itemType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'setting';
    var itemDocument = arguments.length > 2 ? arguments[2] : undefined;
    var metadataForType;
    var modelExprToWatch;
    if (isUserEditingUnsavedDoc && !confirm('You are editing an unsaved item. Discard it?')) {
      return;
    }
    isUserEditingUnsavedDoc = false;
    $scope.selectedKey = itemKey;
    $scope.selectedItemType = itemType;
    $scope.selectedComponentEntry = null;
    if (itemType === 'nav') {
      var _config = $scope.selectedNavEditorConfig = navEditors[itemKey];
      $scope.selectedNavEditor = registryNavEditors[_config.editor];
    } else if (itemType === 'setting' || itemType === 'item') {
      var formMetadata = _.map(metadataForType = registry[itemKey] || metadata[itemDocument.fp_type], function (item, key) {
        return _.extend({}, item, {
          field: key
        });
      });
      if (itemType === 'item') {
        formMetadata = formMetadata.filter(function (m) {
          return m.field.indexOf('_') !== 0;
        });
      }

      // only let one targets or exceptions filter through because the single widget caters for both
      $scope.formMetadata = metadataService.filterDuplicateTargetsExceptionsFields(formMetadata);

      // pull the defaults out of the registry and into our local settings doc
      // NOTE: we must clone each property value so that we are not modifying the registry's copy
      var defaults = metadataForType ? metadataService.extractDefaults(metadataForType) : {};
      if (itemType === 'setting') {
        settings[itemKey] = $scope.formModel = _.extend({}, defaults, settings[itemKey] || (settings[itemKey] = {}));
        // ⚑
        // TODO: hack because timestamps are no longer converted to strings by the api (regression)
        timeService.convertTimestampsToHumanFormInObject(settings[itemKey], formMetadata, event.timezone);

        // we keep a reference to this so that we can compute our changes later on
        // unfortunately must be a DEEP CLONE because we don't want to change inner nested-objects and lists via the form !
        originalSettingsForKey = JSON.parse(JSON.stringify(settings[itemKey]));
      } else {
        $scope.formModel = itemDocument;
      }
      modelExprToWatch = 'formModel';
    } else if (itemType === 'i18n') {
      var selectedI18nValue = $scope.selectedI18nValue = (0, _lodash.get)(i18n, itemKey, {});
      $scope.selectedI18nMetadata = i18nService.getMetadataForI18nEditor(selectedI18nValue);
      modelExprToWatch = 'selectedI18nValue';
    } else {
      return;
    }

    // watch selected item doc for changes
    $scope.$watch(modelExprToWatch, function (newValue, oldValue) {
      if (!oldValue || angular.equals(newValue, oldValue)) {
        return;
      }
      return $scope.setNavigationWarningMessage('You may have made changes. Discard them?');
    }, true);
    // delete any custom item docs that are unsaved (those that have _is_unsaved_prefs_items_doc set)
    _.values(customPreferencesPaneDocs).forEach(function (list) {
      // it'll only ever be the first doc that has this flag set
      // (because we unshift the new doc and there is only ever one)
      if ((list || {}).length && (list[0] || {})._is_unsaved_prefs_item_doc) {
        return list.shift();
      }
    });
    // a very grubby scroll-to-top hack
    angular.element($window).scrollTop(0);
  };
  $scope.saveSettingsOrItem = function (itemKey, itemType, itemDocument) {
    var successCb = function successCb() {
      $scope.setFlashMessage('The settings have been saved.');
      $scope.setNavigationWarningMessage(null);
      return $route.reload();
    };
    var errCb = function errCb(err) {
      alert('There was a problem saving the settings item.');
      $log.error('settings save error!', err);
      return $scope.saveInProgress = false;
    };
    $scope.saveInProgress = true;
    if (itemType === 'item') {
      if (!itemDocument) {
        return;
      }
      var funcName = itemDocument._is_unsaved_prefs_item_doc ? 'createDocs' : 'updateDoc';
      delete itemDocument._is_unsaved_prefs_item_doc;
      return bulkUpdateService[funcName](eventId, event.node, itemDocument.fp_type, itemDocument).then(successCb, errCb);
    } else {
      // settings!
      return settingsService.saveLocalSettingsAsOverrides(event, settings, itemKey, originalSettingsForKey, registry).then(successCb, errCb);
    }
  };
  $scope.saveI18n = function (selectedI18nKey, i18nValue) {
    var errCb = function errCb(err) {
      alert('There was a problem updating the i18n dictionary.');
      $log.error('i18n save error!', err);
      return $scope.saveInProgress = false;
    };
    $scope.saveInProgress = true;
    return i18nService.updateOverrideNavBitWithSingleEdit(event, selectedI18nKey, i18nValue).then(function () {
      $scope.setFlashMessage('The translations have been updated.');
      $scope.setNavigationWarningMessage(null);
      return $scope.saveInProgress = false;
    }, errCb);
  };
  $scope.onNavBitsSavedCallback = function (bits) {
    var savedNavIds = _.pluck(bits, 'fp_subtype');
    var savedNavIdsStr = savedNavIds.toString().replace(/,/g, ', ');
    $scope.setFlashMessage("The following navs were saved: ".concat(savedNavIdsStr));
    $scope.setNavigationWarningMessage(null);
    return $scope.saveInProgress = false;
  };
  $scope.showAddI18nLanguageToMetadataPrompt = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(i18nFields) {
      var langs, langCode;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            langs = i18nFields.map(function (l) {
              return l.field;
            });
            _context.next = 3;
            return modalService.openModal({
              templateUrl: '/static/partials/components/modal-language-picker.html',
              scope: {
                lang: '',
                langs: langs
              }
            });
          case 3:
            langCode = _context.sent;
            if (langCode.length) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            i18nFields.push({
              field: langCode,
              label: langCode.toUpperCase()
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  $scope.getLabelForModel = function (model) {
    var m = model;
    var l = metadataService.getReprLabelForItem(eventId, m);
    return l || m.name || m.title || m.subject || m.fp_ext_id || m._id || '(unsaved)';
  };
  $scope.getNameForKey = function (key) {
    return key === 'person' ? 'user' : key;
  };

  // select the first available setting OR i18n on load
  if ((settingsKeys || {}).length) {
    return $scope.selectItem(_.first(settingsKeys), 'setting');
  } else if ((i18nKeys || {}).length) {
    return $scope.selectItem(_.first(i18nKeys), 'i18n');
  }
}];